'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.formatUrl = void 0;
var formatUrl = function (r) {
    try {
        return r ? 0 === (r = r.trim()).indexOf('http:') ? r.replace('http:', '') : 0 === r.indexOf('https:') ? r.replace('https:', '') : 0 === r.indexOf('/') ? 0 === r.indexOf('//') ? r : '/'.concat(r) : '//'.concat(r) : r;
    } catch (t) {
        return console.error(t), r;
    }
};
exports.formatUrl = formatUrl;